import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../atoms/Button';
import { useDispatch } from 'react-redux';
import { setModalId } from '../../../store/slices/publicSlice';

export default function Actions({ loading }: { loading?: boolean }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  return (
    <div className="flex items-center justify-end gap-x-2 !mt-8">
      <Button
        size="md"
        variant="outline"
        type="button"
        disabled={loading}
        className="min-w-[160px]"
        onClick={() => dispatch(setModalId({ id: null, extraData: {} }))}
      >
        {t('cancel')}
      </Button>

      <Button size="md" type="submit" disabled={loading}>
        {t('home.send')}
      </Button>
    </div>
  );
}
